import React from "react";
import { Modal, StyleSheet, Text, View } from "react-native";
import Ionicons from "react-native-vector-icons/Ionicons";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import Button from "./Button";

export default function BetterAlert({
  show,
  title,
  message,
  cancelText,
  confirmText,
  pressCancel,
  pressConfirm,
  type,
}) {
  let assets = { icon: "", color: "" };

  switch (type) {
    case "warning":
      assets = { icon: "warning-outline", color: Colors.WARNING };
      break;
    case "success":
      assets = { icon: "checkmark-circle-outline", color: Colors.SUCCESS };
      break;
    case "alert":
      assets = { icon: "alert-circle-outline", color: Colors.ALERT };
      break;
    case "info":
      assets = { icon: "information-circle-outline", color: Colors.INFO };
      break;
    default:
      assets = { icon: "information-circle-outline", color: Colors.INFO };
      break;
  }


  return (
    <Modal
      animationType="fade"
      transparent={true}
      style={{ backgroundColor: "#000" }}
      visible={!!show}
      statusBarTranslucent={true}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <View style={styles.titleView}>
            <Ionicons name={assets.icon} size={40} color={assets.color} />
            <Text style={styles.titleText}>{title}</Text>
          </View>
          <View style={styles.subTitleView}>
            <Text style={styles.subTitleText}>{message}</Text>
          </View>
          <View style={styles.viewButton}>
            {cancelText && pressCancel ? (
              <Button
                textoBotao={cancelText}
                estilo={{
                  backgroundColor: Colors.ALERT,
                  marginRight: 8,
                }}
                onPress={() => {
                  pressCancel();
                }}
              />
            ) : null}
            {confirmText && pressConfirm ? (
              <Button
                textoBotao={confirmText}
                estilo={{ backgroundColor: Colors.SUCCESS }}
                onPress={() => {
                  pressConfirm();
                }}
              />
            ) : null}
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.3)",
  },
  titleView: {
    marginBottom: 8,
    alignItems: "center",
  },
  titleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_20,
    fontWeight: "bold",
    color: Colors.BLACK
  },
  subTitleView: {
    alignItems: "center",
    width: "90%",
  },
  subTitleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.GRAY_DARK,
  },
  modalView: {
    margin: 20,
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    padding: 16,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "80%",
  },
  closeButton: {
    marginLeft: "auto",
    color: Colors.GRAY_DARK,
  },
  viewButton: {
    marginTop: 16,
    flexDirection: "row",
  },
  amountText: {
    fontSize: Fonts.FONT_SIZE_24,
    color: Colors.BLACK,
    fontWeight: "500",
  },
});
